import { useMemo } from "react";
import {
  TransformWrapper,
  TransformComponent,
} from "react-zoom-pan-pinch";
import { Box, IconButton } from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";

const imageType = ["jpg", "jpeg", "png", "gif", "bmp", "tiff", "ico", "webp"];

export default function ImagePreview({ imageUrl, fileType = "jpg" }) {

  // const checkFileType = useCallback(
  //   (type) => {
  //     if (type === "pdf") {
  //       setFileType("pdf");
  //     } else {
  //       setFileType("image");
  //     }
  //   },
  //   [imageUrl]
  // );

  // useEffect(() => {
  //   setType(type);
  // }, [type]);

  const RenderElement = useMemo(() => {
    if (fileType === "pdf") {
      return (
        <div style={{ width: "100%", height: "100%", position: "relative" }}>
          <iframe
            src={imageUrl}
            title="PDF Viewer"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        </div>
      );
    } else if (imageType.includes(fileType)) {
      return (
        <img
          src={imageUrl}
          alt="ImagePreview"
          style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
        />
      );
    }
  }, [fileType, imageUrl]);

  return (
    <TransformWrapper 
      initialScale={1} 
      minScale={0.5} 
      maxScale={5} 
      centerOnInit
      wheel={{ step: 0.1 }}
      pinch={{ step: 5 }}
    >
      {(utils) => (
        <>
          {fileType !== "pdf" && <Controls {...utils} />}

          <TransformComponent
            wrapperStyle={{
              width: "100%",
              height: "100%",
              cursor: "grab",
              borderRadius: "12px",
              backgroundColor: "black",
            }}
            contentStyle={
              fileType === "pdf"
                ? {
                    width: "100%",
                    height: "100%",
                    cursor: "grab",
                    position: "relative",
                  }
                : {
                    // width: "100%",
                    // height: "100%",
                    // display: "flex",
                    // alignItems: "center",
                    // justifyContent: "center",
                  }
            }
          >
            {RenderElement}
          </TransformComponent>
        </>
      )}
    </TransformWrapper>
  );
}

const Controls = ({ zoomIn, zoomOut, resetTransform }) => (
  <Box
    sx={{
      position: "absolute",
      top: "10px",
      right: "15px",
      p: "2px",
      display: "flex",
      background: "rgba(255, 255, 255, 0.8)",
      borderRadius: 5,
      zIndex: 10,
    }}
  >
    <IconButton onClick={() => zoomIn()} size="small">
      <ZoomInIcon />
    </IconButton>
    <IconButton onClick={() => zoomOut()} size="small">
      <ZoomOutIcon />
    </IconButton>
    <IconButton onClick={() => resetTransform()} size="small">
      <RotateLeftIcon />
    </IconButton>
  </Box>
);

